function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { ButtonClose } from '@arc/frontend/ui-buttons';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "opde7s",
  styles: "color:inherit"
} : {
  name: "1stodz0-ToastCloseButton",
  styles: "color:inherit;label:ToastCloseButton;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function ToastCloseButton({
  closeToast
}) {
  return <ButtonClose onClick={closeToast} css={_ref} data-testid="close-toast" />;
}